import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Coffee } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden bg-[#0a0a0a]" data-id="element-27">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-28">
        <img src="https://images.unsplash.com/photo-1497935586351-b67a49e012bf?q=80&w=2671&auto=format&fit=crop" alt="Coffee texture background" className="w-full h-full object-cover opacity-40 grayscale contrast-125" data-id="element-29" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" data-id="element-30" />
        {/* Grain/Texture Overlay */}
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')] mix-blend-overlay" data-id="element-31" />
      </div>

      {/* Vertical Sidebar Text (Desktop) */}
      <div className="hidden lg:flex absolute right-0 top-0 bottom-0 w-24 z-20 items-center justify-center border-l border-white/10 bg-black/20 backdrop-blur-sm" data-id="element-32">
        <div className="text-vertical rotate-180 flex items-center gap-8 text-white/80 font-bebas tracking-widest text-lg" data-id="element-33">
          <span className="text-[#D97E3A]" data-id="element-34">OPEN DAILY 7AM - 2PM</span>
          <span className="w-px h-12 bg-white/30" data-id="element-35"></span>
          <span data-id="element-36">925.292.0433</span>
          <span className="w-px h-12 bg-white/30" data-id="element-37"></span>
          <span data-id="element-38">LIVERMORE, CA</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-12 lg:px-24 max-w-[1800px] mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col" data-id="element-40">
          {/* Brand Tag */}
          <div className="flex items-center gap-3 mb-6" data-id="element-41">
            <div className="h-px w-12 bg-[#D97E3A]" data-id="element-42"></div>
            <span className="text-[#D97E3A] font-inter font-medium tracking-widest text-sm uppercase" data-id="element-43">
              Est. 2023
            </span>
          </div>

          {/* Massive Headline */}
          <h1 className="font-bebas text-white leading-[0.85] tracking-tight" data-id="element-44">
            <span className="block text-[15vw] lg:text-[12rem]" data-id="element-45">COFFEE IS</span>
            <span className="block text-[15vw] lg:text-[12rem] text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-white/50" data-id="element-46">
              COMMUNITY
            </span>
          </h1>

          {/* Tagline & CTAs */}
          <div className="mt-8 md:mt-12 flex flex-col md:flex-row items-start md:items-end gap-8 md:gap-16" data-id="element-47">
            <p className="text-white/80 font-inter text-lg md:text-xl max-w-md leading-relaxed border-l-2 border-[#D97E3A] pl-6" data-id="element-48">
              A neighborhood coffee shop, by neighborhood folks.
              <br data-id="element-49" />
              <br data-id="element-50" />
              Dedicated to fostering community.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-51">
              <motion.a href="https://order.dripos.com/Grounded-Livermore" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-[#D97E3A] text-white px-8 py-4 font-bebas text-xl tracking-wide hover:bg-[#c06b2e] transition-colors flex items-center justify-center gap-2" data-id="element-52">
                ORDER NOW
                <Coffee size={20} data-id="element-53" />
              </motion.a>

              <motion.button whileHover={{
              scale: 1.05,
              backgroundColor: 'rgba(255,255,255,0.1)'
            }} whileTap={{
              scale: 0.95
            }} className="border border-white text-white px-8 py-4 font-bebas text-xl tracking-wide hover:border-[#D97E3A] hover:text-[#D97E3A] transition-colors flex items-center justify-center gap-2" data-id="element-54">
                ABOUT US
                <ArrowRight size={20} data-id="element-55" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/50" data-id="element-56">
        <span className="text-[10px] uppercase tracking-widest font-inter" data-id="element-57">
          Scroll
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent" data-id="element-58"></div>
      </motion.div>
    </section>;
}